module.exports = __webpack_public_path__ + "media/images/logo-white-e5f5befeb0b7c3a2a8614873b3cc3001.png";